<template>
  <div>
    <ValidationProvider
      v-slot="{ classes, errors }"
      :name="`Datastore table ${usedFor}`"
      :rules="`${isRequired ? 'required' : ''}`"
    >
      <div
        class="control"
        :class="isRequired ? classes : ''"
      >
        <Multiselect
          v-model="selection"
          style="margin-top: 0.5em;"
          class="search-usergroups"
          :options="results"
          :options-limit="10"
          :allow-empty="true"
          track-by="table_name"
          label="label"
          :reset-after="false"
          select-label=""
          selected-label=""
          deselect-label=""
          :searchable="true"
          :placeholder="placeholder"
          :show-no-results="true"
          :loading="isLoading"
          :clear-on-select="false"
          :preserve-search="false"
          :disabled="disabled && !text"
          data-test="search-datastore-tables"
          @search-change="search"
          @close="select"
        >
          <template slot="clear">
            <div
              v-if="selection"
              class="multiselect__clear"
              @click.prevent.stop="selection = null"
            >
              <b-icon-x font-scale="2" />
            </div>
          </template>
          <span slot="noResult">
            {{ $t('searchbars.noResult') }}
          </span>
          <span slot="noOptions">
            {{ $t('searchbars.noOptions') }}
          </span>
        </Multiselect>
        <span class="form-errors">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import datastoreAPI from '../../api/modules/resource/datastore.api';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'SearchDatastoreTables',

  components: {
    Multiselect,
    ValidationProvider
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    datastoreTables:{
      type:Array,
      default:() => { return []; }
    },
    table: {
      type: Object,
      default: () => { return {}; }
    },
    disabled: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    resetAfter: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Rechercher une table ...'
    },
    type: {
      type: String,
      default: 'geospatial'
    },
    datastore: {
      type: String,
      default: ''
    },
    usedFor: {
      type: String,
      default: 'resource'
    }
  },

  data() {
    return {
      selection: null,
      isLoading: false,
      text: null,
      results: [],
      isRequired: false
    };
  },


  watch: {
    loading(newValue) {
      this.isLoading = newValue;
    },
    disabled(newValue) {
      if (!newValue) {
        this.results = this.datastoreTables;
      }
    },
    required(newValue) {
      this.isRequired = newValue;
    },

    table: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selection = newValue;
        }
      }
    },

    text: function(newValue) {
      this.isLoading = true;
      
      datastoreAPI.getTablesList(this.type,this.datastore,newValue)
        .then((tables) => {
          this.results=tables.map(el => {
            return { ...el, label: `${el.schema_name}.${el.table_name}` };
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    
    },
  },

  created() {
    if (this.table) {
      this.selection = this.table;
    }
    this.isRequired = this.required;
  },

  methods: {

    search(text) {
      this.text = text;
    },

    select() {
      this.$emit('select', this.selection);
    },

    clear() {
      this.selection = null;
    }
  }
};
</script>
